// ----------------------------------------------------------------------
// <copyright file="Izenda.ZoomForMap.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * Zoom For Map Component
 */
!(function() {
  var m = require('mobx');
  var React = require('react');
  var ChartSettingsContainer = require('./Izenda.ChartSettingsContainer');
  var ChartConfig = require('logic/data/Izenda.ChartDefaultConfig');
  var localizer = require('share/localization/Izenda.Localizer');
  var { MAP_TYPES } = require('logic/data/Izenda.ReportPartMapConstants');
  var { get, isFunction } = require('lodash/fp');
  var ZoomConfigSettings = React.createClass({
    /**
     * Get inittial state
     */
    getInitialState: function() {
      var props = this.props;
      var value = props.value || {};
      var enabled = value['izMapNavigation.enabled'] || false;
      var horizontalAlign = value['izMapNavigation.align'] || ChartConfig.DefaultConfig.LEGEND_HORIZONTAL_ALIGNMENT;
      var verticalAlign = value['izMapNavigation.verticalAlign'] || ChartConfig.DefaultConfig.LEGEND_VERTICAL_ALIGNMENT;

      this.allChartProps = props.allChartProps;
      let allChartPropsValue = (isFunction(this.allChartProps) ? this.allChartProps() : this.allChartProps) || {};
      this.chartType = get('chartOptions.chartType', allChartPropsValue);

      return {
        enabled: enabled,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign
      };
    },

    /**
     * Handle changed value of zoom config setting
     * @param  {object} schemaData schema data
     */
    onChangeValue: function(
      schemaData: any,
      changedKey: string,
      changedKeyPath: any,
      changedValue: any,
      changedOthersInfo: any
    ) {
      const groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
      const fieldData = groupData[changedKey];

      fieldData && (fieldData.value = changedValue);

      var enabled = schemaData.enabled.value;
      var horizontalAlign = schemaData.horizontalAlignment.value;
      var verticalAlign = schemaData.verticalAlignment.value;

      this.setState({
        enabled: enabled,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign
      });
    },

    /**
     * Get value of zoom config component
     */
    getValue: function() {
      var state = this.state;

      return {
        'izMapNavigation.enabled': state.enabled,
        'izMapNavigation.align': state.horizontalAlign,
        'izMapNavigation.verticalAlign': state.verticalAlign
      };
    },

    getConfigurationDef: function() {
      var state = this.state;

      /**
       * Define zoom config setting component schema
       * @return {object} background component schema
       */
      var getSchema = () => {
        return {
          schemaKey: 'ZOOM_CONFIG_SCHEMA',
          fields: {
            enabled: {
              title:
                this.chartType === MAP_TYPES.Google
                  ? localizer.getText('REPORTDESIGNER_LABEL_ENABLED_ZOOM_CONTROL')
                  : localizer.getText('REPORTDESIGNER_LABEL_ENABLED'),
              type: 'checkbox',
              fnValue: 'getEnabled'
            },
            horizontalAlignment: {
              title: localizer.getText('REPORTDESIGNER_LABEL_HORIZONTAL_ALIGNMENT'),
              type: 'select',
              fnValue: 'getHorizontalAlignment',
              props: {
                options: ChartConfig.getOptions('HORIZONTAL_ALIGN'),
                defaultValue: ChartConfig.DefaultConfig.LEGEND_HORIZONTAL_ALIGNMENT,
                disabled: !state.enabled
              }
            },
            verticalAlignment: {
              title: localizer.getText('REPORTDESIGNER_LABEL_VERTICAL_ALIGNMENT'),
              type: 'select',
              fnValue: 'getVerticalAlignment',
              props: {
                options: ChartConfig.getOptions('VERTICAL_ALIGN'),
                defaultValue: ChartConfig.DefaultConfig.LEGEND_VERTICAL_ALIGNMENT,
                disabled: !state.enabled
              }
            }
          }
        };
      };

      return {
        definedSchema: getSchema(),
        onChangeValue: this.onChangeValue,
        mappingSource: {
          getEnabled: function() {
            return state.enabled;
          },

          getHorizontalAlignment: function() {
            return state.horizontalAlign;
          },

          getVerticalAlignment: function() {
            return state.verticalAlign;
          }
        }
      };
    },

    render: function() {
      var state = this.state;
      var props = this.props;

      this.allChartProps = this.allChartProps;
      var chartOptions = {
        optionByType: {
          'izMapNavigation.enabled': state.enabled,
          'izMapNavigation.align': state.horizontalAlign,
          'izMapNavigation.verticalAlign': state.verticalAlign
        }
      };

      return (
        <ChartSettingsContainer
          type={this.props.reportPartType}
          configurationDef={this.getConfigurationDef()}
          chartOptions={chartOptions}
          allChartProps={this.allChartProps}
        />
      );
    }
  });

  module.exports = ZoomConfigSettings;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ChartSettings/Izenda.ZoomForMap.jsx